export default (defaultQuantity) => ({
	defaultQuantity,
	quantity: 4,

	init() {
		this.quantity = defaultQuantity
	},

	minusButton: {
		['@click.prevent']() {
			if (this.quantity > 1) {
				this.quantity--
			}
		},

		[':disabled']() {
			return this.quantity <= 1
		},
	},
	plusButton: {
		['@click.prevent']() {
			this.quantity++
		},

		[':disabled']() {
			return this.quantity >= 99
		},
	},

	input: {
		['@keydown.shift.up'](e) {
			e.preventDefault()
			this.quantity += 10
		},

		['@keydown.shift.down'](e) {
			e.preventDefault()
			this.quantity -= 10

			if (this.quantity < 1) {
				this.quantity = 1
			}
		},
	},

	amount: {
		['x-html']() {
			if (this.quantity === defaultQuantity) {
				return `${this.$el.dataset.amount}`
			}

			const baseValue = this.$el.dataset.amount.toString().toFloat()

			let calculatedAmount = (this.quantity / defaultQuantity) * baseValue

			const formatter = new Intl.NumberFormat('nl', {
				maximumFractionDigits: 2,
			})

			return `${formatter.format(calculatedAmount)}`
		},
	},
})
